import React from 'react';

export const PdpRespHeroCarouselTradeOnApprovalCalloutLazy = React.lazy(() =>
    import(/* webpackChunkName: "TradeOnApprovalCallout" */ './PdpRespHeroCarouselTradeOnApprovalCallout')
);
